export default {
  features: {
    applicationChangeStatusToDelivery: {
      button: 'Yetkazib berishga o‘tkazish',
      desc: 'Mahsulotni yetkazib berishda sizning tomoningizdan',
    },
  },
};
